module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_1.9c871db0.mp3";